import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import * as Swiper from 'swiper/dist/js/swiper.js';
import '../../interfaces/slider.interface';
import './vertical-scroller.component.scss';
var VerticalScroller = /** @class */ (function (_super) {
    tslib_1.__extends(VerticalScroller, _super);
    function VerticalScroller(element) {
        return _super.call(this, element) || this;
    }
    VerticalScroller.prototype.init = function () {
        var _this = this;
        this.sliderItems = Number(this.element.getAttribute('data-items'));
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderButtons = Array.from(this.element.querySelectorAll('.vertical-scroller__button'));
        this.windowWidth = document.documentElement.clientWidth;
        this.breakpoints = {};
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            direction: 'vertical',
            breakpoints: this.breakpoints,
            allowTouchMove: false,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        // if (this.element.getAttribute('data-direction')) {
        // 	if (this.element.getAttribute('data-direction') === 'vertical') {
        // 		this.sliderConfig.direction = 'vertical';
        // 	}
        // }
        this.sliderComponent = new Swiper(this.sliderContainer, this.sliderConfig);
        this.sliderComponent.on('slideChange', function (event) {
            var index = _this.sliderComponent.realIndex;
            _this.activeState(index);
        });
    };
    VerticalScroller.prototype.bindEvents = function () {
        var _this = this;
        this.sliderButtons.map(function (item) { return item.addEventListener('click', function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var index = element.getAttribute("data-slide");
            _this.sliderComponent.slideTo(index - 1, true);
        }); });
    };
    VerticalScroller.prototype.activeState = function (index) {
        if (index === void 0) { index = 0; }
        var indexSlide = index + 1;
        var buttons = Array.from(this.element.querySelectorAll('.vertical-scroller__button'));
        buttons.map(function (button) {
            button.classList.remove('vertical-scroller__items--active');
            var buttonIndex = parseInt(button.getAttribute("data-slide"));
            if (indexSlide === buttonIndex) {
                button.classList.add('vertical-scroller__items--active');
            }
        });
        this.stopVideos();
    };
    VerticalScroller.prototype.stopVideos = function () {
        var videosVidavee = Array.from(this.element.querySelectorAll('video'));
        var videosYoutube = Array.from(this.element.querySelectorAll('#video__external'));
        videosVidavee.map(function (video) {
            if (video.player) {
                video.player.pause();
            }
        });
        videosYoutube.map(function (video) {
            // video.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        });
    };
    return VerticalScroller;
}(Base));
export { VerticalScroller };



//////////////////
// WEBPACK FOOTER
// ./components/vertical-scroller/vertical-scroller.component.ts
// module id = 574
// module chunks = 0